import { useState, useEffect } from "react";

const NAV = [
  { id: "work", idx: "01", label: "Work" },
  { id: "experience", idx: "02", label: "Experience" },
  { id: "about", idx: "03", label: "About" },
  { id: "capabilities", idx: "04", label: "Capabilities" },
  { id: "certificates", idx: "05", label: "Certificates" },
  { id: "contact", idx: "06", label: "Contact" },
];

const CV_URL = "/AbdulBasitiqbal_CV.pdf";

const ArrowUpRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <path d="M7 17L17 7M17 7H8M17 7V16" />
  </svg>
);

function Header() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header id="header">
        <nav className="nav">
          <a href="#home" className="brand" aria-label="Home">
            Abdul Basit<span className="dot">.</span>
          </a>
          <div className="nav-links">
            {NAV.map((n) => (
              <a key={n.id} href={`#${n.id}`} className="nlink" data-section={n.id}>
                <span className="idx">{n.idx}</span>
                {n.label}
              </a>
            ))}
            <a href={CV_URL} target="_blank" rel="noreferrer" className="resume-btn">
              Résumé
              <ArrowUpRight />
            </a>
          </div>
          <button
            className="menu-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M3 7h18M3 17h18" />
            </svg>
          </button>
        </nav>
      </header>

      <div className={`mobile-menu${open ? " open" : ""}`} id="mobileMenu">
        {NAV.map((n) => (
          <a key={n.id} href={`#${n.id}`} className="mm" onClick={() => setOpen(false)}>
            <span className="midx">{n.idx}</span>
            {n.label}
          </a>
        ))}
        <a
          href={CV_URL}
          target="_blank"
          rel="noreferrer"
          className="mm-resume"
          onClick={() => setOpen(false)}
        >
          Download Résumé →
        </a>
      </div>
    </>
  );
}

export default Header;
